import * as angular from "angular";
import {IController} from "angular";

export class BringozCountryCodeSelectCtrl implements IController {
  countryCode: any;
  isDisabled: boolean;
  onChange: Function;

  public countries: any;
  public siteCountryCode: any;

  constructor(private commonsConstants, private splitService) {
    this.countries = this.commonsConstants.countries;
    this.siteCountryCode = this.splitService.getCountryCode();
  }

  $onInit() {}

  $onChanges(changes) {}

}

angular
  .module('bringoz.admin.commons')
  .component('bringozCountryCodeSelect', {
    bindings: {
      countryCode: '<',
      isDisabled: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/bringoz-country-code-select/bringoz-country-code-select.html',
    controller: BringozCountryCodeSelectCtrl
  });
